// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dataFormShell[data-v-f21a6304]{display:flex;flex-direction:column;width:100%;gap:0}.dataFormShell__control[data-v-f21a6304]{width:100%}.dataFormShell__fieldHint[data-v-f21a6304]{margin:6px 0 0;font-size:var(--link-text-xs);color:var(--link-ink-muted);line-height:1.4}", ""]);
// Exports
module.exports = exports;
